module.exports = __webpack_public_path__ + "img/receive-course.a6785c53.png";